import { setupIntercomUser } from "./user";

const INTERCOM_SCRIPT_ID = "__intercom";

type IntercomQueue = ((...args: unknown[]) => void) & {
  q: unknown[][];
  c: (args: unknown[]) => void;
};

const loadIntercomScript = (intercomAppId: string): void => {
  if (document.getElementById(INTERCOM_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = INTERCOM_SCRIPT_ID;
  script.type = "text/javascript";
  script.async = true;
  script.src = `https://widget.intercom.io/widget/${intercomAppId}`;
  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);

    return;
  }

  document.head.appendChild(script);
};

const setupIntercom = (intercomAppId: string): void => {
  window.intercomSettings = {
    ...window.intercomSettings,
    api_base: "https://api-iam.intercom.io",
    app_id: intercomAppId,
    hide_default_launcher: true,
  };

  setupIntercomUser();

  const intercom = window.Intercom;
  if (typeof intercom === "function") {
    intercom("reattach_activator");
    intercom("update", window.intercomSettings);

    return;
  }

  const intercomQueue: IntercomQueue = (...args: unknown[]) => {
    intercomQueue.c(args);
  };
  intercomQueue.q = [];
  intercomQueue.c = (args: unknown[]) => {
    intercomQueue.q.push(args);
  };
  window.Intercom = intercomQueue;

  if (document.readyState === "complete") {
    loadIntercomScript(intercomAppId);

    return;
  }

  if (window.intercomLoadListener) {
    window.removeEventListener("load", window.intercomLoadListener, false);
  }

  window.intercomLoadListener = () => {
    loadIntercomScript(intercomAppId);
  };
  window.addEventListener("load", window.intercomLoadListener, false);
};

export { setupIntercom };
